var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.hasNewLeftNavEnabled
        ? _c("new-main-header", [_vm._v("\n    Customer Devices\n  ")])
        : _c("main-header", [
            _c(
              "span",
              { attrs: { slot: "arrow-back" }, slot: "arrow-back" },
              [
                _c(
                  "el-tooltip",
                  {
                    staticClass: "item",
                    attrs: {
                      effect: "dark",
                      content: "Back to Start Page",
                      placement: "bottom-start",
                    },
                  },
                  [
                    _c("router-link", { attrs: { to: { name: "HomePage" } } }, [
                      _c("i", { staticClass: "el-icon-back" }),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("span", { attrs: { slot: "page-title" }, slot: "page-title" }, [
              _vm._v("Customer Devices"),
            ]),
          ]),
      _vm._v(" "),
      _c(
        "main-content",
        [
          false
            ? _c(
                "el-menu",
                {
                  staticClass: "ring-menu--horizontal",
                  attrs: {
                    slot: "horizontal-menu",
                    "default-active": "1",
                    mode: "horizontal",
                  },
                  slot: "horizontal-menu",
                },
                [
                  _c(
                    "el-menu-item",
                    {
                      directives: [
                        {
                          name: "scroll-to",
                          rawName: "v-scroll-to",
                          value: {
                            el: "#devices__ring-devices-table",
                            container: "#main-content",
                            duration: 500,
                            easing: "linear",
                          },
                          expression:
                            "{\n            el: '#devices__ring-devices-table',\n            container: '#main-content',\n            duration: 500,\n            easing: 'linear'}",
                        },
                      ],
                      attrs: { index: "1" },
                    },
                    [_c("span", [_vm._v("Ring Devices")])]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-menu-item",
                    {
                      directives: [
                        {
                          name: "scroll-to",
                          rawName: "v-scroll-to",
                          value: {
                            el: "#devices__third-party-devices-table",
                            container: "#main-content",
                            duration: 500,
                            easing: "linear",
                          },
                          expression:
                            "{\n            el: '#devices__third-party-devices-table',\n            container: '#main-content',\n            duration: 500,\n            easing: 'linear'}",
                        },
                      ],
                      attrs: { index: "2" },
                    },
                    [_c("span", [_vm._v("Third Party Devices")])]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-menu-item",
                    {
                      directives: [
                        {
                          name: "scroll-to",
                          rawName: "v-scroll-to",
                          value: {
                            el: "#devices__client-devices-table",
                            container: "#main-content",
                            duration: 500,
                            easing: "linear",
                          },
                          expression:
                            "{\n            el: '#devices__client-devices-table',\n            container: '#main-content',\n            duration: 500,\n            easing: 'linear'}",
                        },
                      ],
                      attrs: { index: "3" },
                    },
                    [_c("span", [_vm._v("Client Devices")])]
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "main-content" }, slot: "main-content" },
            [
              _c("devices-table", {
                attrs: {
                  id: "devices__ring-devices-table",
                  "customer-id": _vm.customer.id,
                },
              }),
              _vm._v(" "),
              _c("third-party-devices-table", {
                attrs: { id: "devices__third-party-devices-table" },
              }),
              _vm._v(" "),
              _c("accessories", { attrs: { customer: _vm.customer } }),
              _vm._v(" "),
              _c("client-devices", {
                staticClass: "span-12 span-12-t",
                staticStyle: { "min-height": "400px" },
                attrs: {
                  id: "devices__client-devices-table",
                  customer: _vm.customer,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }